(function () {

    'use strict';

    angular
        .module('app.core')
        .constant('APP_CONFIG', {
            HASH_PREFIX: '!',
            DEFAULT_HOME: "home"
        });

})();


// WEBPACK FOOTER //
// ./app/core/configuration/AppConfig.js